export { default } from './volume-slash'
